import React from 'react';
interface WordmarkProps {
  variant?: 'stacked' | 'horizontal';
  color?: 'white' | 'black';
  className?: string;
}
export function Wordmark({
  variant = 'stacked',
  color = 'white',
  className = ''
}: WordmarkProps) {
  const textColor = color === 'white' ? 'text-white' : 'text-ink';
  const lineColor = color === 'white' ? 'bg-white' : 'bg-ink';
  if (variant === 'horizontal') {
    return <div className={`flex items-center gap-2 ${textColor} ${className}`} data-id="element-232">
        <span className="font-serif text-sm md:text-base tracking-[0.15em] uppercase" data-id="element-233">
          The Spaces Between
        </span>
        <span className="font-mono text-[10px] tracking-[0.1em] opacity-70" data-id="element-234">
          /
        </span>
        <span className="font-mono text-[10px] tracking-[0.1em] uppercase" data-id="element-235">
          Interior | Design
        </span>
      </div>;
  }
  return <div className={`flex flex-col items-center font-serif uppercase ${textColor} ${className}`} data-id="element-236">
      <div className="text-3xl md:text-5xl tracking-[0.3em] mb-4" data-id="element-237">
        The Spaces
      </div>
      <div className="flex items-center gap-4 md:gap-6" data-id="element-238">
        <span className="text-[10px] md:text-xs font-mono tracking-[0.2em]" data-id="element-239">
          Interior
        </span>
        <div className={`w-[1px] h-8 md:h-10 ${lineColor}`} data-id="element-240"></div>
        <div className="text-3xl md:text-5xl tracking-[0.15em]" data-id="element-241">Between</div>
        <div className={`w-[1px] h-8 md:h-10 ${lineColor}`} data-id="element-242"></div>
        <span className="text-[10px] md:text-xs font-mono tracking-[0.2em]" data-id="element-243">
          Design
        </span>
      </div>
    </div>;
}